import React from "react";
import PropTypes from 'prop-types';
import RenderComponentProto from "../../render-component-proto";

import InlineTextarea from '../../../../gd-components/inline-edit/textarea/textarea.jsx';
import StringInListWithPopover from "./string-list-with-popover";

export default class TextField extends RenderComponentProto {

    static props = {
        id: PropTypes.string.isRequired, // CF id
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,

        onTogglePopover: PropTypes.func,
        onChange: PropTypes.func,
        //old
        params: PropTypes.object,
        onFocusCallback: PropTypes.func,
        onBlurCallback: PropTypes.func,
        stateless: PropTypes.bool // ????
    };

    static defaultProps = {
        canEdit: false
    };

    constructor(props) {
        super(props);

        this._bind('onFocus','onBlur','onChange');

        this.state = {
            isEditing: false,
            value: props.value
        }
    }

    onChange(newValue) {
        if (!newValue) newValue = '';

        const { onChange } = this.props;
        this.setState({value: newValue}, ()=>{
            if (onChange) onChange(newValue)
        });
    }

    onFocus(e) {
        this.setState({isEditing: true}, ()=> {
            if (this.props.onFocus) this.props.onFocus(e)
        });
    }

    onBlur(e) {
        this.setState({isEditing: false}, ()=>{
            if (this.props.onBlur) this.props.onBlur(e);
        });
    }

    renderListView() {
        const classes = Classes('gd-field-text','list');

        return (
            <div className={classes}>
                {this.state.value}
            </div>
        )
    }

    render() {
        let classes;

        if (this.props.renderMode === 'list') {
            return <StringInListWithPopover value={this.state.value} {...this.props}/>;
        }

        if (this.props.renderMode === 'edit') {
            classes = Classes('gd-field-text','view','edit',{
                'disabled': this.props.canEdit === false,
            });
        } else {
            classes = Classes('gd-field-text',this.props.renderMode,{
                'edit': this.state.isEditing,
                'disabled': this.props.canEdit === false,
            });
        }

        const cf = gd.session.customFields.get(this.props.id);
        const maxSize = _.get(cf,'params.size', 4);

        return (
            <div className={classes}>
                <InlineTextarea className=""
                                placeholder=""
                                value={this.state.value}
                                disabled={(this.props.canEdit === false)}

                                onChange={this.onChange}

                                onFocus={this.onFocus}
                                onBlur={this.onBlur}

                                commitDelay={2000}
                                rows={maxSize}
                                maxRows={maxSize}
                                cols={60} />
            </div>
        );
    }
}